module.exports = __webpack_public_path__ + "static/img/dd.de57fa68.png";